module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAKCAYAAACE2W/HAAABEElEQVQoU43RvUrEQBAH8JkjBInKiWglvoZo7SNY2HhdmN3OVuzsBIuAEMxsQgJWYqH3AYqInaAPcZVvYGdYdkeid4KHd+e28/8NszNojLkRkS0AeIP5LwKADefcLjLzEADeAeBQKfU8zaZpuhQEQRcAPhDxDo0xL3Vd74Vh2BORY6314yRm5jYA9BHxwnsfIGL7CxLRDjOvjYqnRNQf46IoVr33g1ardRbHcTfLsoNfsAkmSbISRVGv6UxEV2VZrltrB4h4QkT3TeZP2BRGf7lFxAcR2ReRI63103iCqbAJVFW1YK09F5HLyYXNhLOu8gOZ+VUptT3/hN8JY0wHAJYxz/NrEdkUEfknXnTOdT4BB2yJn/IG22kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/email.png
// module id = DbE1
// module chunks = 1